"use client";

import { useParams, useSearchParams } from "next/navigation";
import { useQuery } from "@tanstack/react-query";
import { AdminBreadcrumb, AdminTitle, PanelError, PanelLoader } from "@/shared";
import {
  adminArticleRead,
  AdminArticlePath,
  AdminArticleTitle,
} from "@/entities";
import {
  AdminArticleListButton,
  AdminCommonFileCoverEdit,
  AdminCommonFileFilesEdit,
} from "@/features";
import { AdminArticleForm } from "./ArticleForm";
import { AdminArticleAlert } from "@/features";

export function AdminArticleViewPage() {
  const params = useParams<{ id: string }>();
  const searchParams = useSearchParams();

  const id = params?.id || "";

  const { error, isLoading, data } = useQuery({
    queryKey: [`admin-articles-${id}`],
    queryFn: () => adminArticleRead({ id }),
  });

  return (
    <>
      <div className="d-flex align-items-center">
        <div>
          <AdminBreadcrumb items={AdminArticlePath} />
          <AdminTitle title={AdminArticleTitle} />
        </div>
        <div className="ms-auto">
          <AdminArticleListButton />
        </div>
      </div>

      <AdminArticleAlert />

      {error ? (
        <PanelError error={error} />
      ) : (
        <>
          <div className="row">
            <div className="col-md-4">
              {isLoading ? (
                <PanelLoader panelTitle="커버 이미지" />
              ) : (
                <AdminCommonFileCoverEdit
                  panelTitle="커버 이미지"
                  queryKey={`admin-articles-${data?.result.id}`}
                  table="article"
                  column="cover"
                  id={data?.result.id}
                  timestamp={data?.result.timestamp}
                  file={data?.result.cover}
                  accept="image/*"
                />
              )}
            </div>
            <div className="col-md-8">
              {isLoading ? (
                <PanelLoader panelTitle="첨부파일" />
              ) : (
                <AdminCommonFileFilesEdit
                  panelTitle="첨부파일"
                  queryKey={`admin-articles-${data?.result.id}`}
                  table="article"
                  column="files"
                  id={data?.result.id}
                  timestamp={data?.result.timestamp}
                  files={data?.result.files}
                  // accept="image/*"
                />
              )}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-12">
              {isLoading ? (
                <PanelLoader panelTitle="글정보" />
              ) : (
                <AdminArticleForm panelTitle="글정보" data={data} />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}
